import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import ServiceIcon, { SERVICE_ORDER } from "../components/ServiceIcon";

export default function ServicesPage() {
  const { t } = useLang();
  return (
    <main data-testid="services-page">
      <Seo title={t.seo.services.title} desc={t.seo.services.desc} />
      <PageHero
        eyebrow={t.servicesIndex.eyebrow}
        title={t.servicesIndex.title}
        sub={t.servicesIndex.sub}
      />

      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICE_ORDER.map((slug, i) => {
              const s = t.services[slug];
              return (
                <Reveal key={slug} delay={0.05 * i}>
                  <Link
                    to={`/services/${slug}`}
                    data-testid={`services-page-card-${slug}`}
                    className="group flex h-full flex-col rounded-2xl border border-sand/50 bg-cream/60 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-terracotta/50 hover:bg-white hover:shadow-[0_20px_40px_-15px_rgba(56,39,25,0.2)]"
                  >
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-teal/10 text-teal">
                      <ServiceIcon slug={slug} />
                    </span>
                    <h2 className="mt-5 font-serif text-xl sm:text-2xl font-medium text-espresso">{s.name}</h2>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-espresso/70">{s.short}</p>
                    <div className="mt-6 flex items-center justify-between">
                      {s.price ? (
                        <span className="font-mono text-sm font-medium text-terracotta">
                          {s.price}
                          {s.priceNote ? ` ${s.priceNote}` : ""}
                        </span>
                      ) : (
                        <span className="font-mono text-sm text-teal">{t.common.customQuote}</span>
                      )}
                      <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal">
                        {t.common.learnMore}
                        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              );
            })}
          </div>

          <Reveal className="mt-14">
            <p className="mx-auto max-w-3xl rounded-2xl border border-sand/50 bg-cream p-6 text-center text-sm leading-relaxed text-espresso/75" data-testid="services-disclaimer-note">
              {t.common.noGuaranteeNote}
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
